import React from 'react';

const SunIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41
             M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
);

const HouseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z" />
    <path d="M9 21V12h6v9" />
  </svg>
);

const NetworkIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="5" r="2" />
    <circle cx="4"  cy="19" r="2" />
    <circle cx="20" cy="19" r="2" />
    <path d="M12 7v4m0 0l-6.5 6M12 11l6.5 6" />
  </svg>
);

const services = [
  {
    icon: <SunIcon />,
    title: 'Energetische Sanierung',
    text:
      'Wir modernisieren Ihr Gebäude energetisch und steigern nachhaltig den Wert Ihrer Immobilie – von der Analyse bis zum Fördermittelantrag.',
    items: ['Wärmedämmung & Fassade', 'Fenster & Türen', 'Photovoltaik & Solar', 'Fördermittelberatung'],
  },
  {
    icon: <HouseIcon />,
    title: 'Haussanierung',
    text:
      'Komplettsanierungen und Teilrenovierungen – wir koordinieren alle Gewerke und sorgen für einen reibungslosen Ablauf direkt aus einer Hand.',
    items: ['Bäder & Böden', 'Malerarbeiten', 'Elektrik & Haustechnik', 'Innen- & Außensanierung'],
  },
  {
    icon: <NetworkIcon />,
    title: 'Beratung & Planung',
    text:
      'Ob Neubau oder Bestand: Wir beraten Sie unabhängig, erstellen Sanierungskonzepte und vermitteln die passenden Fachbetriebe aus unserem Netzwerk.',
    items: ['Energieberatung', 'Sanierungsfahrplan', 'Projektmanagement', 'Kooperationspartner'],
  },
];

export default function Leistungen() {
  return (
    <section className="section" id="leistungen">
      <div className="container">

        <div className="leistungen__head">
          <span className="section-label">Was wir tun</span>
          <h2 className="section-title">Unsere Leistungen</h2>
          <p className="section-subtitle">
            Aus einer Hand, mit einem Ansprechpartner – für Ihr Projekt in Hamburg,
            Bremen und dem norddeutschen Raum.
          </p>
        </div>

        <div className="leistungen__grid">
          {services.map(s => (
            <div key={s.title} className="leistungen__card">
              <div className="leistungen__icon">{s.icon}</div>
              <h3 className="leistungen__card-title">{s.title}</h3>
              <p className="leistungen__card-text">{s.text}</p>
              <ul className="leistungen__items">
                {s.items.map(item => (
                  <li key={item} className="leistungen__item">{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
